import type {
  GetUserScopeExclusionsPageArgs,
  GetUserScopesPageArgs,
} from '../services/users.service';
import type {
  UserScopeExclusionRecord,
  UserScopeRecord,
  UserScopeExclusionsPagingResponse,
  UserScopesPagingResponse,
} from '../models';

const PAGE_SIZE = 200;

type ScopesPageFetcher = (
  args: GetUserScopesPageArgs
) => { unwrap: () => Promise<UserScopesPagingResponse> };

type ExclusionsPageFetcher = (
  args: GetUserScopeExclusionsPageArgs
) => { unwrap: () => Promise<UserScopeExclusionsPagingResponse> };

export async function loadAllUserScopes(
  fetchPage: ScopesPageFetcher,
  userId: string
): Promise<UserScopeRecord[]> {
  const acc: UserScopeRecord[] = [];
  let offset = 0;

  for (;;) {
    const page = await fetchPage({
      userId,
      limit: PAGE_SIZE,
      offset,
    }).unwrap();

    acc.push(...page.items);

    if (acc.length >= page.count || page.items.length === 0) {
      break;
    }
    offset += PAGE_SIZE;
  }

  return acc;
}

export async function loadAllUserScopeExclusions(
  fetchPage: ExclusionsPageFetcher,
  userId: string
): Promise<UserScopeExclusionRecord[]> {
  const acc: UserScopeExclusionRecord[] = [];
  let offset = 0;

  for (;;) {
    const page = await fetchPage({
      userId,
      limit: PAGE_SIZE,
      offset,
    }).unwrap();

    acc.push(...page.items);

    if (acc.length >= page.count || page.items.length === 0) {
      break;
    }
    offset += PAGE_SIZE;
  }

  return acc;
}
